import { Link } from 'react-router-dom';
import { bool } from 'components/columns';
import type { EmbeddedUser } from 'modules/core/types';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

export const columns: ControlledTableColumns<EmbeddedUser> = [
  flexColumn({
    content: 'Email',
    key: 'email',
    required: true,
    render: ({ id, email }: EmbeddedUser) => <Link to={id.toString()}>{email}</Link>,
    minWidth: 180,
  }),
  {
    content: 'First name',
    key: 'first_name',
    width: 160,
  },
  {
    content: 'Last name',
    key: 'last_name',
    width: 160,
  },
  bool('Active', 'is_active'),
  bool('Manage group', 'manage_group'),
  bool('Superuser', 'is_superuser'),
];
